import { combineReducers } from 'redux';

import profile from './profile';
import user from './user';

export default combineReducers({
  profile,
  user,
});
